import { APP_CONFIG } from "@/config/app-config";
import { isPublicError, PublicError } from "@/domain/errors/common";

function servicesErrorHandler(
  error: unknown,
  fallback: PublicError
): PublicError {
  const environment = APP_CONFIG.getCurrentEnvironment();

  if (environment !== "development") {
    return isPublicError(error) ? error : fallback;
  }

  console.error(error); // in development, log all errors
  if (error instanceof Error) {
    return isPublicError(error)
      ? error
      : new PublicError(`ONLY_DEV_ERROR: ${error.message}`);
  }

  // if it's not an Error, we don't know what it is
  return new PublicError("An unknown error occurred, check the console");
}

export { servicesErrorHandler };
